var clientId = '482147591471-vda3c6ii1gu034c01an36enssocjvk4e.apps.googleusercontent.com'; //choose web app client Id, redirect URI and Javascript origin set to http://localhost
var API_KEY = 'AIzaSyBvYv1WCYNJ3rWUUo7G_DOEmAIzRcSDXEE'; //choose public apiKey, any IP allowed (leave blank the allowed IP boxes in Google Dev Console)
var userEmail = "07d7f62j18jpfse6454r5n4i6k@group.calendar.google.com"; //your calendar Id
var userTimeZone = "London"; //example "Rome" "Los_Angeles" ecc...
var maxRows = 12; //events to shown
var calName = "Upcoming Santa Cruz / Juliana Demo events"; //name of calendar 
    
var scopes = 'https://www.googleapis.com/auth/calendar';
    
//--------------------- Add a 0 to numbers
function padNum(num) {
    if (num <= 9) {
        return "0" + num;
    }
    return num;
}
//--------------------- end    
    
//--------------------- From 24h to Am/Pm

var mornAft = "am";
function AmPm(num) {
    if (num <= 12) { mornAft = "am"; return num; }
    mornAft = "pm";
    return padNum(num - 12);
}
//--------------------- end    

//--------------------- num Month to String
function monthString(num) {
         if (num === "01") { return "JAN"; } 
    else if (num === "02") { return "FEB"; } 
    else if (num === "03") { return "MAR"; } 
    else if (num === "04") { return "APR"; } 
    else if (num === "05") { return "MAY"; } 
    else if (num === "06") { return "JUN"; } 
    else if (num === "07") { return "JUL"; } 
    else if (num === "08") { return "AUG"; } 
    else if (num === "09") { return "SEP"; } 
    else if (num === "10") { return "OCT"; } 
    else if (num === "11") { return "NOV"; } 
    else if (num === "12") { return "DEC"; }
}
//--------------------- end

//--------------------- from num to day of week
function dayString(num){
         if (num == "1") { return "mon" }
    else if (num == "2") { return "tue" }
    else if (num == "3") { return "wed" }
    else if (num == "4") { return "thu" }
    else if (num == "5") { return "fri" }
    else if (num == "6") { return "sat" }
    else if (num == "0") { return "sun" }
    else if (num == "7") { return "sun" }
}
//--------------------- end

//--------------------- client CALL
function handleClientLoad() {
    gapi.client.setApiKey(API_KEY);
    checkAuth();
}
//--------------------- end

//--------------------- check Auth
function checkAuth() {
    gapi.auth.authorize({client_id: clientId, scope: scopes, immediate: true}, handleAuthResult);
}
//--------------------- end

//--------------------- handle result and make CALL
function handleAuthResult(authResult) {
    if (authResult) {
      
        makeApiCall();
    }
}
//--------------------- end


function isImageOk(img) {
    

    if (img.naturalWidth === 0) {
    
        return false;
    }

    return true;
}


//--------------------- API CALL itself
async function makeApiCall() {

    var today = new Date(); //today date






    gapi.client.load('calendar', 'v3', function () {
        var request = gapi.client.calendar.events.list({
            'calendarId' : userEmail,
            'timeZone' : userTimeZone, 
            'singleEvents': true, 
            'timeMin': today.toISOString(), //gathers only events not happened yet
            'maxResults': maxRows,
            'supportsAttachments': true, 
            'orderBy': 'startTime'});
    request.execute(function (resp) {

        if(resp.items.length > 0){

            for (var i = 0; i < resp.items.length; i++) {
                var li = document.createElement('li');
                var item = resp.items[i];

                var eventTitle = item.summary;
       
                if(typeof item.attachments !== 'undefined'){
                    var bg_pic = 'https://drive.google.com/uc?id=' + item.attachments[0].fileId;
                }else{
                    var bg_pic = 'https://cdn.shopify.com/s/files/1/0557/0615/7234/files/demo_bg.jpg?v=1617791876';
                }
                
                var location = item.location;
                var eventDesc = item.description;
                
                //var allDay = item.start.date? true : false;
                //var startDT = allDay ? item.start.date : item.start.dateTime;

                var startDT = item.start.dateTime;
                var dateTime = startDT.split("T"); //split date from time
                var date = dateTime[0].split("-"); //split yyyy mm dd
                var startYear = date[0];
                var startMonth = monthString(date[1]);
                var startDay = date[2];
                
                var startDateISO = new Date(startMonth + " " + startDay + ", " + startYear + " 00:01:00");
                var startDayWeek = dayString(startDateISO.getDay());
                
                
                var time = dateTime[1].split(":"); //split hh ss etc...
                var startHour = AmPm(time[0]);
                var startMin = time[1];


                //endtime
                var endDT = item.end.dateTime;
                var endDateTime = endDT.split("T"); //split date from time
                
                var endTime = endDateTime[1].split(":"); //split hh ss etc...
                var endHour = AmPm(endTime[0]);
                var endMin = endTime[1];

                var eventBlock = '<div class = "grid__item medium-up--one-third small--one-whole event_container"><div class = "event_image_container"><img class = "demo__event_image" src="'+bg_pic+'"><div class = "event_date_container"><span class = "event_day_of_week">'+startDayWeek+'</span><span class = "event_day_numeric">'+startDay+'</span><span class = "event_month">'+startMonth+'</span></div></div><div class = "event_details"><h2>'+eventTitle+'</h2><p><i class="fas fa-map-marker red_icon"></i><span class = "event_where"> '+location+'</span></p><p><i class="far fa-clock red_icon"></i><span class = "event_time_start"> '+startHour+':'+startMin + mornAft+'</span> - <span class = "event_time_end">'+endHour+':'+endMin + mornAft+'</span></p><p><i class="fas fa-info-circle red_icon"></i><span class = "event_deets"> '+eventDesc+'</span></p></div></div>';


                // var str = [ //change this to match your needs
                //     '<font size="4" face="courier">',
                //     startDayWeek, ' ',
                //     startMonth, ' ',
                //     startDay, ' ',
                //     startYear, ' - ',
                //     startHour, ':', startMin, mornAft, '</font><font size="5" face="courier"> @ ', item.summary , '</font><br><br>'
                //     ];
                
                

                // li.innerHTML = str.join('');
                // document.getElementById('events').appendChild(li);

                $('#demo_events_container').append(eventBlock);
            }
        //document.getElementById('updated').innerHTML = "updated " + today;
        $('#loading_demo').remove(0);
        //check all images have loaded and if not, replace with shopifty served backup

        $(".demo__event_image").each(function(){
            
            if( isImageOk( $(this) ) ){
                //all good
            }else{
                $(this).attr('src', 'https://cdn.shopify.com/s/files/1/0557/0615/7234/files/demo_bg.jpg?v=1617791876');
            }
        })
    }else{
        $('#loading_demo').html('No upcoming events found. Contact your local demo center (see below) to arrange a demo ride.');
    }
        
            

        });
    });
}
//--------------------- end

// link to dealer map for demo centers

$('.demo_partner_block-inner').click(function(){
    var dealerName = encodeURI($(this).attr('data-dealer'));
    var target = '/pages/dealers?dealer=' + dealerName;
    window.location.href = target;

})

